import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';

import { BaseActionButton } from '../shared/base-button';

@Component({
  selector: 'hypecast-admin-buttons-cancel',
  templateUrl: './buttons-cancel.component.html',
  styleUrl: './buttons-cancel.component.scss',
  standalone: true,
  imports: [MatRippleModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonsCancelComponent extends BaseActionButton {
  override readonly clicked = output<void>();
}
